import React from 'react';

function AboutAttributesDiseases() {
  return (
    <div id="section43">
      <h3>Diseases</h3>
      <p>
        The vocabulary used for diseases in DISGENET is the
        <a href="https://www.nlm.nih.gov/research/umls/index.html" target="_blank" rel="noreferrer">
          {' '}
          UMLS<sup>®</sup> Metathesaurus<sup>®</sup>.
        </a>{' '}
        Each disease has a Concept Unique Identifier (CUI) from the Unified Medical Language System
        <sup>®</sup> (UMLS) Metathesaurus<sup>®</sup> (version UMLS 2024AB).
      </p>
      {/* <div>
              <p>
                <strong>Diseases in DISGENET are annotated with: </strong>
              </p>
              <ul>
                <li className="bullet-item">
                  The disease name, provided by the{' '}
                  <a
                    className="tt"
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.nlm.nih.gov/research/umls/"
                  >
                    UMLS<sup>®</sup> Metathesaurus<sup>®</sup>
                  </a>
                </li>
                <li className="bullet-item">
                  The{' '}
                  <a
                    className="tt"
                    target="_blank"
                    rel="noreferrer"
                    href="http://www.nlm.nih.gov/research/umls/META3_current_semantic_types.html"
                  >
                    UMLS<sup>®</sup> semantic types{' '}
                  </a>
                  the{' '}
                  <a className="tt" target="_blank" rel="noreferrer" href="https://meshb.nlm.nih.gov/treeView">
                    MeSH
                  </a>{' '}
                  class: we classify the diseases according the MeSH hierarchy using the upper level concepts of
                  the MeSH tree branch C (Diseases) plus three concepts of the F branch (Psychiatry and
                  Psychology: "Behavior and Behavior Mechanisms", "Psychological Phenomena and Processes", and
                  "Mental Disorders")
                </li>
                <li className="bullet-item">
                  The top level concepts from the{' '}
                  <a className="tt" target="_blank" rel="noreferrer" href="http://disease-ontology.org/">
                    Human Disease Ontology
                  </a>
                </li>
                <li className="bullet-item">
                  The top level concepts from the{' '}
                  <a className="tt" target="_blank" rel="noreferrer" href="https://hpo.jax.org/app/">
                    Human Phenotype Ontology
                  </a>
                </li>
                <li className="bullet-item">
                  The DISGENET disease type: <b>disease</b>, <b>phenotype</b> and <b>group</b>.
                </li>
              </ul>
            </div> */}
      <div>
        <p>
          <strong>
            We consider a <b>disease</b> entries mapping to the following UMLS<sup>®</sup> semantic types:
          </strong>
        </p>
        <ul>
          <li className="bullet-item">Disease or Syndrome</li>
          <li className="bullet-item">Neoplastic Process</li>
          <li className="bullet-item">Acquired Abnormality</li>
          <li className="bullet-item">Anatomical Abnormality</li>
          <li className="bullet-item">Congenital Abnormality</li>
          <li className="bullet-item">Mental or Behavioral Dysfunction</li>
        </ul>
      </div>
      <div>
        <p>
          <strong>
            We consider a <b>phenotype</b> entries mapping to the following UMLS<sup>®</sup> semantic types:
          </strong>
        </p>
        <ul>
          <li className="bullet-item">Pathologic Function</li>
          <li className="bullet-item">Sign or Symptom</li>
          <li className="bullet-item">Finding</li>
          <li className="bullet-item">Laboratory or Test Result</li>
          <li className="bullet-item">Individual Behavior</li>
          <li className="bullet-item">Injury or Poisoning</li>
          <li className="bullet-item">Mental Process</li>
          <li className="bullet-item">Clinical Attribute</li>
          <li className="bullet-item">Organism Attribute</li>
          <li className="bullet-item">Organism Function</li>
          <li className="bullet-item">Physiologic Function</li>
          <li className="bullet-item">Organ or Tissue Function</li>
          <li className="bullet-item">Cell or Molecular Dysfunction</li>
          <li className="bullet-item">Cell Function</li>
          <li className="bullet-item">Behavior</li>
        </ul>
      </div>
      <div>
        <p>
          Other annotations for diseases include <strong>mode of inheritance</strong> and{' '}
          <strong>prevalence</strong> for Mendelian disorders. <strong>Mode of inheritance</strong> describes
          the type(s) of inheritance associated with a given disease, and is obtained from literature review
          by{' '}
          <a href="https://www.google.com/url?q=https://www.orphadata.com/docs/OrphadataFreeAccessProductsDescription.pdf">
            Orphanet
          </a>
          .
        </p>
        <p>
          It includes the following types: Autosomal dominant, Autosomal recessive, X-linked dominant,
          X-linked recessive, Chromosomal, Mitochondrial inheritance, Multigenic/multifactorial, Oligogenic,
          Semi-dominant, Y-linked, No data available, Not applicable, Not yet documented.
        </p>
        <p>
          <strong>Prevalence</strong> information is obtained from literature review by{' '}
          <a href="https://www.google.com/url?q=https://www.orphadata.com/docs/OrphadataFreeAccessProductsDescription.pdf">
            Orphanet
          </a>{' '}
          and includes the following fields:
        </p>
        <p>
          <ul>
            <li className="bullet-item">
              Prevalence Type: defines the methodological approach used to quantify prevalence, depending on
              the timeframe and population context, such as “point prevalence”, “prevalence at birth”,
              “lifelong prevalence”, “annual incidence”, “cases/families”.
            </li>
            <li className="bullet-item">
              Prevalence Class: estimated prevalence of a given disease. There are eight possible values: 1 /
              1,000, 1–5 / 10,000, 6–9 / 10,000, 1–9 / 100,000, 1–9 / 1,000,000, &lt;1 / 1,000,000, Not yet
              documented, Unknown.
            </li>
            <li className="bullet-item">
              Prevalence Geography: Geographic area of a given prevalence type. Values include countries and
              continents.
            </li>
          </ul>
        </p>
      </div>
      {/* <p>
              These classifications were manually checked. In addition, disease entries referring to disease
              groups such as "Cardiovascular Diseases", "Autoimmune Diseases", "Neurodegenerative Diseases, and
              "Lung Neoplasms" were classified as <b>disease group</b>.
            </p>
            <div>
              Additionally, we have removed terms considered as diseases by other sources, but are not strictly
              diseases, such as terms belonging to the following UMLS
              <sup>®</sup> semantic types:
              <ul>
                <li className="bullet-item">Gene or Genome</li>
                <li className="bullet-item">Genetic Function</li>
                <li className="bullet-item">Immunologic Factor</li>
                <li className="bullet-item">Injury or Poisoning</li>
              </ul>
            </div> */}
    </div>
  );
}
export default AboutAttributesDiseases;
